// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromMedium":"(min-width: 640px)","mainText":"Gaa34ab"};